import React from 'react';
import { connect } from 'react-redux';
import { toggleManufacturerFiltersPopup } from "../../Account/AccountActions";
import {saveManufacturerFilters} from "../../AddNewEntity/AddNewEntityActions";


class ManufacturerFiltersPopup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filters: [],
        }
    }

    componentDidMount() {
        const filters = this.props.manufacturerFilters.manufacturerFilters;
        this.setState({ ...this.state, filters });
    }

    closePopup = () => {
        this.props.toggleManufacturerFiltersPopup(false);
    };

    saveManufacturerFilters = () => {
        this.props.saveManufacturerFilters(this.state.filters).then((res) => res && this.closePopup());
    }

    handleFilterCheckbox = (e) => {
        const { entityId } = this.props.accountPageInfo;

        const filterId = Number(e.target.id.replace("filter_", ''));
        const updatedFilters = this.state.filters.map(f => {
            if (f.filterGroupValueId === filterId) {
                if (e.target.checked) {
                    f.fabricatorId = entityId;
                } else {
                    f.fabricatorId = null;
                }
            }
            return f;
        });
        this.setState({ ...this.state, fabricators: updatedFilters });
    }

    render() {
        const { entityId } = this.props.accountPageInfo;
        const filters = this.state.filters;

        return (<div className="ui-popup">
            <div className="ui-popup-header">
                <span className="ui-popup-header__text">Manufacturer Filters</span>
                <button className="ui-popup-header__close" onClick={this.closePopup} />
            </div>
            <div className="ui-popup-body ui-popup-body--tiny">

                <ul className="ui-list export-fabricators-list">
                    {
                        filters.map((f) => {
                            return (
                                <li key={f.filterGroupValueId}>
                                    <div className="feature-inclusion-popup-row">
                                        <div className={f.fabricatorId && f.fabricatorId.toString() !== entityId ? 'ui-checkbox2--disabled' : 'ui-checkbox2'}>
                                            <input type="checkbox"
                                                id={`filter_${f.filterGroupValueId}`}
                                                onChange={this.handleFilterCheckbox}
                                                checked={f.fabricatorId && f.fabricatorId.toString() === entityId}
                                                />
                                            <label htmlFor={`filter_${f.filterGroupValueId}`}>{f.filterGroupValueName}</label>
                                        </div>
                                    </div>
                                </li>)
                        })
                    }
                </ul>

            </div>
            <div className="ui-popup-footer">
                <button className="ui-button ui-button--blue" onClick={this.closePopup}>
                    <span className="ui-button-text ui-button--uppercase">Cancel</span>
                </button>
                <button className="ui-button ui-button--green" onClick={this.saveManufacturerFilters}>
                    <span className="ui-button-text ui-button--uppercase">Save</span>
                </button>
            </div>
        </div>);
    }
}

const mapStateToProps = (store) => {
    return {
        manufacturerFilters: store.accountState.manufacturerFilters,
        accountPageInfo: store.accountState.accountPageInfo
    };
};

const mapDispatchToProps = {
    toggleManufacturerFiltersPopup,
    saveManufacturerFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(ManufacturerFiltersPopup);
